import React, { useContext, useEffect }from 'react';

import PresentPC from 'components/pages/AddThanks/PresentPC';
import PresentSP from 'components/pages/AddThanks/PresentSP';
import { 
  useWindowDimensions,
  useDirectTransCheck,
  useIECheck,
  MoveCheckStop,
  scrollTop,
} from 'utils';
import { LP_URL } from 'utils/constant';

import AppContext from 'fluxes/context';
import { REGISTER } from 'fluxes/actions';

const AddThanks = ()=>{
  const { state, dispatch } = useContext(AppContext);


  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStop();


  // クリア
  useEffect(() => {
    dispatch({ type: REGISTER });
  }, [ dispatch ]);
  
  const onClickMainButton = {
    next: () => {
      scrollTop();
      window.location.href = LP_URL;
    },
  };
  return isSp ? (
    <PresentSP
      onClickMainButton={onClickMainButton}
    />
  ) : (
    <PresentPC
      onClickMainButton={onClickMainButton}
    />
  );
};

export default AddThanks;